import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { toDateKey } from '../schedule/constants';
import { dayAttendance, eventAttendance, groupByDate, shortLevel } from './scheduleState';

const WEEKDAYS = ['Нд', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'];

const dateFromKey = (key) => new Date(`${key}T00:00:00`);

const hideBrokenFlag = (e) => e.currentTarget.classList.add('is-broken');

const ScheduleListV2 = ({ events, monthLabel, selectedDate, onPickDay, onPrev, onNext }) => {
  const byDate = useMemo(() => groupByDate(events), [events]);
  const days = useMemo(() => Object.keys(byDate).sort(), [byDate]);
  const today = toDateKey(new Date());

  return (
    <div className="sv2-list">
      <div className="sv2-list__card sv2-strip">
        <div className="sv2-strip__nav">
          <button type="button" className="sv2-strip__arrow" aria-label="Попередній місяць" onClick={onPrev}>‹</button>
          <span className="sv2-strip__month">{monthLabel}</span>
          <button type="button" className="sv2-strip__arrow" aria-label="Наступний місяць" onClick={onNext}>›</button>
        </div>
        {days.length > 0 && (
          <div className="sv2-strip__days">
            {days.map((key) => {
              const date = dateFromKey(key);
              const state = dayAttendance(byDate[key]);

              return (
                <button
                  type="button"
                  key={key}
                  className={`sv2-day ${state ? `sv2-day--${state}` : ''} ${key === selectedDate ? 'is-selected' : ''} ${key === today ? 'is-today' : ''}`.trim()}
                  onClick={() => onPickDay(date)}
                >
                  <span className="sv2-day__wd">{WEEKDAYS[date.getDay()]}</span>
                  <b className="sv2-day__num">{date.getDate()}</b>
                  <i className="sv2-day__dot" aria-hidden="true"></i>
                </button>
              );
            })}
          </div>
        )}
      </div>

      <div className="sv2-list__card">
        {days.length === 0 && <p className="sv2-empty">У цьому місяці занять немає.</p>}
        <div className="sv2-events">
          {days.map((key) => byDate[key].map((event, idx) => {
            const date = dateFromKey(key);
            const state = eventAttendance(event);
            const level = shortLevel(event.level_name);

            return (
              <button
                type="button"
                key={`${event.id}-${idx}`}
                className={`sv2-event sv2-event--${state}`}
                onClick={() => onPickDay(date)}
              >
                <span className="sv2-event__date">
                  <b>{date.getDate()}</b>
                  <span>{WEEKDAYS[date.getDay()]}</span>
                </span>
                <span className="sv2-event__main">
                  <span className="sv2-event__time">{event.hour}:00 – {Number(event.hour) + 1}:00</span>
                  <span className="sv2-event__name">
                    <img src={event.image} alt="" className="sv2-event__flag" onError={hideBrokenFlag} />
                    {event.direction_short_name}{level ? ` ${level}` : ''}
                  </span>
                </span>
                <span className="sv2-event__side">
                  <span className="sv2-event__type">{event.type_label}</span>
                  {state === 'was' && <span className="sv2-event__state">Відвідано</span>}
                  {state === 'miss' && <span className="sv2-event__state">Пропущено</span>}
                </span>
              </button>
            );
          }))}
        </div>
      </div>
    </div>
  );
};

ScheduleListV2.propTypes = {
  events: PropTypes.array,
  monthLabel: PropTypes.string.isRequired,
  selectedDate: PropTypes.string,
  onPickDay: PropTypes.func.isRequired,
  onPrev: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
};

ScheduleListV2.defaultProps = {
  events: [],
  selectedDate: '',
};

export default ScheduleListV2;
